import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import { initDb } from './db/client';

async function init() {
  try {
    // Initialize database connection
    await initDb();
    
    const root = document.getElementById('root');
    if (!root) {
      throw new Error('Root element not found');
    }
    
    createRoot(root).render(
      <StrictMode>
        <App />
      </StrictMode>
    );
  } catch (error) {
    console.error('Failed to initialize application:', error instanceof Error ? error.message : error);
    const root = document.getElementById('root');
    if (root) {
      // Determine the specific error message to show
      let errorMessage = 'We\'re having trouble connecting to our services.';
      let specificError = '';
      
      if (error instanceof Error) {
        if (error.message.includes('fetch')) {
          errorMessage = 'Unable to connect to the database server.';
          specificError = 'Network connection issue detected.';
        } else if (error.message.includes('auth')) {
          errorMessage = 'Authentication failed when connecting to the database.';
          specificError = 'Please check your Supabase credentials.';
        } else if (error.message.includes('environment')) {
          errorMessage = 'Missing or invalid environment configuration.';
          specificError = 'Please check your environment variables.';
        }
      }

      root.innerHTML = `
        <div style="padding: 20px; text-align: center; font-family: system-ui, -apple-system, sans-serif;">
          <h1 style="color: #EF4444; margin-bottom: 1rem;">Connection Error</h1>
          <p style="color: #374151; margin-bottom: 1rem;">
            ${errorMessage}
          </p>
          ${specificError ? `<p style="color: #6B7280; margin-bottom: 1rem;">${specificError}</p>` : ''}
          <ul style="list-style: none; padding: 0; margin-bottom: 1rem;">
            <li style="margin-bottom: 0.5rem;">1. Check your internet connection</li>
            <li style="margin-bottom: 0.5rem;">2. Verify your environment variables are set correctly</li>
            <li style="margin-bottom: 0.5rem;">3. Confirm the Supabase project is running</li>
            <li>4. Check the browser console for detailed error information</li>
          </ul>
          <div style="display: flex; gap: 1rem; justify-content: center;">
            <button onclick="window.location.reload()" 
                    style="background: #3B82F6; color: white; padding: 0.5rem 1rem; 
                           border-radius: 0.375rem; border: none; cursor: pointer;">
              Refresh Page
            </button>
            <button onclick="console.log('Opening Supabase dashboard...')" 
                    style="background: #4B5563; color: white; padding: 0.5rem 1rem; 
                           border-radius: 0.375rem; border: none; cursor: pointer;">
              Check Supabase Status
            </button>
          </div>
        </div>
      `;
    }
  }
}

init();